export const SET_SELECTED_DELETED_APP = 'SET_SELECTED_DELETED_APP'
export const SET_DELETED_APPLICATIONS = 'SET_DELETED_APPLICATIONS'
export const UPDATE_DELETED_APPLICATION = 'UPDATE_DELETED_APPLICATION'
